import React from 'react';
import { DieuKienThanhToan, DieuKienThanhToanInput } from '@/types/schemas';
import { ErpDataTableV2 } from '@/components/custom/erp/data-table-v2';
import { ConfirmationDialogV2 } from '@/components/custom/erp';
import { getDataTableColumns } from './cols-definition';
import { ActionBar, FormDialog } from './components';
import { useCRUD, useFormState } from '@/hooks';
import { QUERY_KEYS } from '@/constants';

export default function CapNhatDKThanhToanPage() {
  const { addItem, updateItem, deleteItem, refreshData, isLoading, data, totalItems, currentPage, handlePageChange } =
    useCRUD<DieuKienThanhToan, DieuKienThanhToanInput>({
      endpoint: QUERY_KEYS.DIEU_KIEN_THANH_TOAN
    });

  const {
    showForm,
    showDelete,
    selectedObj,
    selectedRowIndex,
    formMode: mode,
    isCopyMode,

    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useFormState();

  const handleSubmit = async (data: BanHangPayload) => {
    try {
      if (mode === 'add') {
        await addItem(data);
      } else if (mode === 'edit' && selectedObj) {
        await updateItem(selectedObj.uuid, data);
      }
      handleCloseForm();
      clearSelection();
    } catch (err: unknown) {
      return;
    }
  };

  const tables = [
    {
      name: '',
      rows: data,
      columns: getDataTableColumns()
    }
  ];
  return (
    <div className='flex h-full min-h-screen w-screen flex-col lg:overflow-hidden'>
      {showForm && (
        <FormDialog
          formMode={mode}
          open={showForm}
          onClose={handleCloseForm}
          onAdd={handleAddClick}
          onEdit={handleEditClick}
          onCopy={handleCopyClick}
          onDelete={handleDeleteClick}
          onSubmit={handleSubmit}
          initialData={mode === 'add' && !isCopyMode ? undefined : selectedObj}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddClick={handleAddClick}
          onEditClick={handleEditClick}
          onDeleteClick={handleDeleteClick}
          onCopyClick={handleCopyClick}
          onViewClick={handleViewClick}
          onRefreshClick={refreshData}
        />
        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          totalItems={totalItems}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          loading={isLoading}
        />
      </div>

      {showDelete && (
        <ConfirmationDialogV2
          open={showDelete}
          onClose={handleCloseDelete}
          onConfirm={() => {
            if (selectedObj?.uuid) deleteItem(selectedObj.uuid);
            handleCloseDelete();
            clearSelection();
            handleCloseForm();
          }}
        />
      )}
    </div>
  );
}
